import GameDataPatch from './lib/GameDataPatch';

export default GameDataPatch;
